<template>
	<div id="activityIntroduction">
		<div class="title">千校招聘线路高校挂网链接（案例）</div>
		<div class="content">
			<el-table v-loading="loading" :data="linkList" stripe :show-header="false" class="linkTable"
				:header-cell-style="{ fontWeight: 'bold', color: '#000' }">
				<el-table-column prop="academy_name" label="院校名称" width="180"></el-table-column>
				<!-- <el-table-column prop="st_time" label="举办时间" width="169"></el-table-column> -->
				<el-table-column label="挂网链接" min-width="600">
					<template slot-scope="scope">
						<a class="externalLink" :href="scope.row.link" target="_blank" rel="noopener noreferrer">
							{{ scope.row.link }}
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ActivityIntroduction',
		data() {
			return {
				loading: false,
				linkList: []
			}
		},
		created() {
			this.getLinkList()
		},
		methods: {
			getLinkList() {
				this.loading = true
				fetch('https://oss.sx985.com/2026/09/02/meetlink.json?_=' + Date.now())
					.then((response) => response.json())
					.then((res) => {
						this.linkList = res && Array.isArray(res.data) ? res.data : []
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.$message.error('挂网链接获取失败，请稍后重试')
					})
			}
		}
	}
</script>

<style scoped>
#activityIntroduction {
	min-height: calc(100vh - 58px);
	padding: 20px;
	box-sizing: border-box;
	background: #f1f5fd;
}

#activityIntroduction .title {
	padding-left: 10px;
	margin-bottom: 20px;
	font-size: 18px;
	font-weight: bold;
	line-height: 20px;
	color: #111;
	border-left: 4px solid #2451cc;
}

#activityIntroduction .content {
	padding: 16px;
	background: #fff;
	border-radius: 12px;
}

#activityIntroduction .linkTable {
	width: 100%;
}

#activityIntroduction .linkTable /deep/ .el-table__header-wrapper .cell {
	font-weight: bold !important;
	color: #000 !important;
}

#activityIntroduction .linkTable /deep/ .el-table__body-wrapper {
	font-family: 'Microsoft YaHei', '微软雅黑', sans-serif !important;
	font-weight: bold;
}

#activityIntroduction .externalLink {
	display: block;
	color: #064eff;
	text-decoration: none;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

#activityIntroduction .externalLink:hover {
	text-decoration: underline;
}
</style>
